import Axios from "axios";
import GlobalConfig from "@/config/index";

//Axios实例初始设置
const AxiosInstance = Axios.create({
  baseURL: process.env.NODE_ENV == "production" ? GlobalConfig.baseurl : "",
  // timeout:20000,
  headers: {'Content-Type': 'application/json'}
});
//全局请求捕获
AxiosInstance.interceptors.request.use(
  (config) => {
    // if (localStorage.getItem("Authorization")) {
    //   config.headers.Authorization = localStorage.getItem("Authorization");
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
AxiosInstance.interceptors.response.use(
  (config) => {
    // if (localStorage.getItem('Authorization')) {
    //     config.headers.Authorization = localStorage.getItem('Authorization');
    // }
    // console.log("response :",config.data);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default AxiosInstance;
